<template>
  <div class="vp-side-panel">
    <div class="vp-panel-section">
      <button class="vp-section-toggle" @click="$emit('toggle-order-data')">
        <span class="vp-section-toggle__label">Datos de la orden</span>
        <svg
          class="vp-section-toggle__chevron"
          :class="{
            'vp-section-toggle__chevron--up': !sectionCollapsed.orderData,
          }"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
        >
          <polyline
            points="6,9 12,15 18,9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            fill="none"
          />
        </svg>
      </button>
      <div v-show="!sectionCollapsed.orderData" class="vp-section-body">
        <order-data :order="order" />
      </div>
    </div>

    <div v-if="events.length > 0" class="vp-panel-section">
      <button class="vp-section-toggle" @click="$emit('toggle-events')">
        <span class="vp-section-toggle__label">Eventos</span>
        <svg
          class="vp-section-toggle__chevron"
          :class="{
            'vp-section-toggle__chevron--up': !sectionCollapsed.events,
          }"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
        >
          <polyline
            points="6,9 12,15 18,9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            fill="none"
          />
        </svg>
      </button>
      <div v-show="!sectionCollapsed.events" class="vp-section-body">
        <Milestones
          :order="order"
          :currentTime="seconds"
          :events="processedEventsForMilestones"
          @goto="$emit('goto', $event)"
        />
      </div>
    </div>

    <AIEventsPanel
      v-if="aiEventsEnabled && !!order.recorderId"
      :collapsed="sectionCollapsed.contextEvents"
      :context-events="contextEvents"
      :loading="loadingContextEvents"
      :active-context-event-id="activeContextEventId"
      @toggle="$emit('toggle-context-events')"
      @select="$emit('select-context-event', $event)"
      @delete="$emit('delete-context-event', $event)"
    />
  </div>
</template>

<script>
import OrderData from "./OrderData";
import Milestones from "./Milestones.vue";
import AIEventsPanel from "./AIEventsPanel.vue";

export default {
  name: "VideoSidePanel",
  components: { OrderData, Milestones, AIEventsPanel },
  props: {
    order: { type: Object, required: true },
    events: { type: Array, required: true },
    processedEventsForMilestones: { type: Array, required: true },
    seconds: { type: [Number, String], required: true },
    sectionCollapsed: { type: Object, required: true },
    contextEvents: { type: Array, required: true },
    loadingContextEvents: { type: Boolean, default: false },
    activeContextEventId: { type: [Number, String], default: null },
    aiEventsEnabled: { type: Boolean, default: false },
  },
};
</script>

<style>
.vp-side-panel {
  width: 256px;
  background: var(--vp-card);
  border-left: 1px solid var(--vp-border);
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.vp-panel-section {
  padding: 0 16px 14px;
  border-bottom: 1px solid var(--vp-border);
}

/* Secciones colapsables */
.vp-section-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--vp-border);
  padding: 12px 0 10px;
  cursor: pointer;
  font-family: inherit;
  margin-bottom: 4px;
  transition: opacity 0.15s;
}
.vp-section-toggle:hover {
  opacity: 0.7;
}
.vp-section-toggle__label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--vp-muted);
}
.vp-section-toggle__label--ai {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--vp-ai);
}
.vp-section-toggle__chevron {
  color: var(--vp-muted);
  flex-shrink: 0;
  transition: transform 0.2s ease;
  transform: rotate(0deg);
}
.vp-section-toggle__chevron--up {
  transform: rotate(180deg);
}
.vp-section-body {
  padding-bottom: 8px;
}

/* Grid datos en panel */
.vp-side-panel .order-data-grid {
  display: grid;
  column-gap: 8px;
  row-gap: 8px;
  padding: 0;
  height: auto;
}
.vp-side-panel .order-data-grid .label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--vp-accent);
}
.vp-side-panel .order-data-grid .value {
  font-size: 13px;
  color: var(--vp-text);
}

@media (min-width: 2560px) {
  .vp-side-panel {
    width: 340px;
  }
}
</style>
